import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  listItem: {
    marginBottom: theme.spacing(3),
  },
  innerList: {
    marginLeft: theme.spacing(4),
    listStyleType: 'lower-latin',
  },
  innerListItem: {
    marginBottom: theme.spacing(1),
  },
  asLink: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
}));
